//import { set, toggle } from '@/utils/vuex'
export default {
	userAuthenticated(state, userRequest) {
		state.isAuthenticated = true;
		state.user = userRequest;
	},
	notAuthenticated(state) {
		state.isAuthenticated = false;
	},
	setUserInfo(state, value) {
		state.userInfo = value;
	},
	setUserForEdition(state, value) {
		state.userForEdition = value;
	},
	//websocket
	setWebsocket(state, value) {
		state.websocket = value;
	},
	//snackbar
	setSnackBar(state, value) {
		state.snackBar = value;
	},
	setSnackText(state, value) {
		state.snackText = value;
	},
	setSnackUserText(state, value) {
		state.snackUserText = value;
	},
	setSnackParameter(state, value) {
		state.snackParameter = value;
	},
	//details drawer
	setDisplayDrawer(state, value) {
		state.displayDrawer = value;
	},
	setDetailedProject(state, value) {
		state.detailedProject = value;
	},
	setProjectRaw(state, value) {
		state.projectRaw = value;
	},
	//project details page
	setProjectForDetails(state, value) {
		state.projectForDetailsPage = value;
	},
	//audit dialog
	setAuditDialog(state, value) {
		state.auditDialog = value;
	},
	setAuditResult(state, value) {
		state.auditResult = value;
	},
	setIsLegalAudit(state, value) {
		state.isLegalAudit = value;
	},
	setAuditProject(state, value) {
		state.auditProject = value;
	},
	//snack downloads
	setSnackDownload(state, value) {
		state.snackDownload = value;
	},
	setSelected(state, value) {
		state.selected = value;
	},
	setProjectDownload(state, value) {
		state.projectDownload = value;
	},
	setDownloadInProgress(state, value) {
		state.downloadInProgress = value;
	},
	setSearch(state, value) {
		state.search = value;
	},
	setSearchInterval(state, value) {
		state.searchInterval = value;
	},
	setPage(state, value) {
		state.page = value;
	},
	setActualPage(state, value) {
		state.actualPage = value;
	},
	setOrganismEdition(state, value) {
		state.organismEdition = value;
	},
	setIsOrganismEditMode(state, value) {
		state.isOrganismEditMode = value;
	},
	setUpdateProjectViewer(state, value) {
		state.updateProjectViewer = value;
	},
	setFooterKey(state, value) {
		state.footerKey = value;
	},
	setWindowWidth(state, value) {
		state.windowWidth = value;
	},
	setStatus(state, value) {
		state.status = value;
	},
	//calendar
	setStartDate(state, value) {
		state.startDate = value;
	},
	setRange(state, value) {
		state.range = value;
	},
	setSelectedItemsPerPage(state, value) {
		state.selectedItemsPerPage = value;
	},
	setSelectedStatistic(state, value) {
		state.selectedStatistic = value;
	},
	//progress download
	setProgressDownload(state, value) {
		state.progressDownload = value;
	},

	setMakeRequest(state, value) {
		state.makeRequest = value;
	},
	setDisableText(state, value) {
		state.disableText = value;
	},
	setSecodaryUpdate(state, value) {
		state.secodaryUpdate = value;
	},
	upStatusKey(state) {
		state.statusKey++;
	},
};
